'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _propTypes2.default.shape({
  /** Name for both the field and the profile object property */
  name: _propTypes2.default.string.isRequired,

  /** Maximum length of the field */
  maxLength: _propTypes2.default.number,

  /** i18n code for the label to be displayed over the field */
  label: _propTypes2.default.string.isRequired,

  /** Whether the field is required or not */
  required: _propTypes2.default.bool,

  /** Whether the field should be hidden or not */
  hidden: _propTypes2.default.bool,

  /** Function returning a mask to be applied on the value */
  mask: _propTypes2.default.func,

  /** A function to evaluate if the value is valid */
  validate: _propTypes2.default.func,

  /** A function to transform received data before displaying */
  display: _propTypes2.default.func,

  /** A function to transform input data before submitting */
  submit: _propTypes2.default.func,

  /** If the input should be disabled or not */
  disabled: _propTypes2.default.bool
});
module.exports = exports['default'];